import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { SignIn } from '../components/auth/SignIn';
import { SignUp } from '../components/auth/SignUp';
import { Home } from '../pages/Home';
import { Profile } from '../pages/Profile';
import { Dashboard } from '../pages/Dashboard/Dashboard';
import { RootLayout } from '../components/layout/RootLayout';
import { Pricing } from '../pages/Pricing';
import { ProtectedRoute } from '../components/auth/ProtectedRoute';
import { ScrollToTop } from '../components/ScrollToTop';
import { Help } from '../pages/Help';
import { Terms } from '../pages/legal/Terms';
import { Privacy } from '../pages/legal/Privacy';
import { Identifier } from '../pages/Identifier/Identifier';
import { DiseaseDetection } from '../pages/DiseaseDetection/DiseaseDetection';
import { NotFound } from '../pages/NotFound';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <>
        <ScrollToTop />
        <RootLayout />
      </>
    ),
    children: [
      { index: true, element: <Home /> },
      { path: 'signin', element: <SignIn /> },
      { path: 'signup', element: <SignUp /> },
      { path: 'pricing', element: <Pricing /> }, // Public route
      { path: 'help', element: <Help /> },
      { path: 'terms', element: <Terms /> },
      { path: 'privacy', element: <Privacy /> },
      {
        path: 'dashboard',
        element: (
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        )
      },
      {
        path: 'identifier',
        element: (
          <ProtectedRoute>
            <Identifier />
          </ProtectedRoute>
        )
      },
      {
        path: 'disease-detection',
        element: (
          <ProtectedRoute>
            <DiseaseDetection />
          </ProtectedRoute>
        )
      },
      {
        path: 'profile',
        element: (
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        )
      },
      { path: '*', element: <NotFound /> }
    ]
  }
]);

export function AppRoutes() {
  return <RouterProvider router={router} />;
}
